export default __webpack_public_path__ + "assets/images/05090dc3d3f66e08dd830514130ded61.svg";